import { createFileRoute } from "@tanstack/react-router";
import AdminPartsFeed from "@/pages/admin/AdminPartsFeed";

export const Route = createFileRoute("/_adminLayout/admin/parts-feed")({
  component: AdminPartsFeed,
});
